import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=8c4c6a24&scoped=true&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"
import style0 from "./pagination.vue?vue&type=style&index=0&id=8c4c6a24&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4c6a24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c4c6a24')) {
      api.createRecord('8c4c6a24', component.options)
    } else {
      api.reload('8c4c6a24', component.options)
    }
    module.hot.accept("./pagination.vue?vue&type=template&id=8c4c6a24&scoped=true&", function () {
      api.rerender('8c4c6a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ui/pagination.vue"
export default component.exports